// frontend/src/components/admin/modules/RemateManager.js
import { api } from '../../../services/api.js';
import { Notification } from '../../../components/Notification.js';
import moment from 'moment-timezone'; // ⭐ AÑADIDO: Necesario para el cierre manual absoluto

// Estado local para esta vista
let remateState = {
    users: [],
    tracks: [],
    currentTrackId: null,
    currentRaceId: null,
    exchangeRate: 0 
};

function createModal(id, contentHTML) {
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const overlay = document.createElement('div');
    overlay.id = id;
    overlay.className = 'user-modal-overlay'; 
    overlay.innerHTML = `<div class="user-modal-content" style="position:relative; width:400px;">${contentHTML}</div>`;
    overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.remove(); });
    return overlay;
}

const openBalanceModal = (user, notificationContainer, onSave) => {
    const content = `
        <h3 style="color:#D4AF37; text-align:center; margin-bottom:10px;">Gestionar Caja y Límites</h3>
        <p style="text-align:center; margin-bottom:15px; color: #f8fafc;">Usuario: <b>${user.alias || user.telegram_username}</b></p>
        
        <div style="background:#0f172a; padding:10px; border-radius:5px; text-align:center; border:1px solid #334155; margin-bottom:15px;">
            <div style="font-size:0.8rem; color:#94a3b8;">Saldo Actual</div>
            <div style="font-size:1.5rem; font-weight:bold; color:#10b981;">$${parseFloat(user.balance_usd || 0).toFixed(2)}</div>
            <div style="font-size:0.9rem; color:#94a3b8;">Bs ${((user.balance_usd || 0) * remateState.exchangeRate).toFixed(2)}</div>
        </div>

        <!-- SECCIÓN: SALDO -->
        <h4 style="color: #4ade80; margin-top: 15px; border-bottom: 1px solid #334155; padding-bottom: 5px; font-size: 0.95rem;"><i class="fas fa-wallet"></i> Mover Saldo (Opcional)</h4>
        <div class="form-grid" style="gap: 10px;">
            <div class="form-group"><label>Monto</label><input type="number" id="balance-amount" class="remate-input" placeholder="0.00"></div>
            <div class="form-group"><label>Moneda</label><select id="balance-currency" class="remate-select"><option value="USD">Dólares ($)</option><option value="VES">Bolívares (Bs)</option></select></div>
        </div>
        <div class="form-group">
            <label>Tipo Operación</label>
            <select id="balance-type" class="remate-select">
                <option value="CREDIT">📥 Recargar (Sumar)</option>
                <option value="DEBIT">📤 Retirar (Restar)</option>
            </select>
        </div>
        <div id="calc-preview" style="color:#D4AF37; font-weight:bold; font-size:0.9rem; text-align: right; margin-bottom: 15px;">= $0.00</div>

        <!-- SECCIÓN: LÍMITES -->
        <h4 style="color: #facc15; margin-top: 15px; border-bottom: 1px solid #334155; padding-bottom: 5px; font-size: 0.95rem;"><i class="fas fa-shield-alt"></i> Límites de Apuesta / Pago</h4>
        <div class="form-grid" style="gap: 10px;">
            <div class="form-group"><label>Max Apuesta ($)</label><input type="number" id="lim-bet" class="remate-input" value="${user.max_bet_limit || ''}" placeholder="Global"></div>
            <div class="form-group"><label>Max Apuestas/Carrera</label><input type="number" id="lim-bets-race" class="remate-input" value="${user.max_bets_per_race || ''}" placeholder="Global"></div>
        </div>
        <div class="form-grid" style="gap: 10px;">
            <div class="form-group"><label>Max Pago USD ($)</label><input type="number" id="lim-payout-usd" class="remate-input" value="${user.max_payout_usd || ''}" placeholder="Sin límite"></div>
            <div class="form-group"><label>Max Pago VES (Bs)</label><input type="number" id="lim-payout-ves" class="remate-input" value="${user.max_payout_ves || ''}" placeholder="Sin límite"></div>
        </div>

        <div style="display:flex; gap:10px; margin-top:20px;">
            <button id="cancel-balance" class="btn btn-secondary" style="flex:1;">Cancelar</button>
            <button id="confirm-balance" class="btn btn-success" style="flex:1;">Guardar Todo</button>
        </div>
    `;
    
    const modal = createModal('balance-modal', content);
    document.body.appendChild(modal);
    
    const modalContent = modal.querySelector('.user-modal-content');
    if(modalContent) modalContent.style.width = '520px';

    const inputAmount = modal.querySelector('#balance-amount');
    const selectCurrency = modal.querySelector('#balance-currency');
    const preview = modal.querySelector('#calc-preview');

    const updatePreview = () => {
        const amount = parseFloat(inputAmount.value) || 0;
        const currency = selectCurrency.value;
        let finalUsd = amount;
        if (currency === 'VES' && remateState.exchangeRate > 0) finalUsd = amount / remateState.exchangeRate;
        preview.textContent = currency === 'VES' ? `Al cambio: $${finalUsd.toFixed(2)}` : `Total: $${finalUsd.toFixed(2)}`;
    };
    inputAmount.addEventListener('input', updatePreview);
    selectCurrency.addEventListener('change', updatePreview);

    modal.querySelector('#confirm-balance').onclick = async () => {
        const btn = modal.querySelector('#confirm-balance');
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Procesando...';

        const amount = parseFloat(inputAmount.value) || 0;
        const currency = selectCurrency.value;
        const type = modal.querySelector('#balance-type').value;

        const maxBet = modal.querySelector('#lim-bet').value;
        const maxBetsRace = modal.querySelector('#lim-bets-race').value;
        const maxPayoutUsd = modal.querySelector('#lim-payout-usd').value;
        const maxPayoutVes = modal.querySelector('#lim-payout-ves').value;

        try {
            const promises = [];

            promises.push(api.put(`/remate/users/${user.id}/limits`, {
                max_bet_limit: maxBet === '' ? null : parseFloat(maxBet),
                max_bets_per_race: maxBetsRace === '' ? null : parseInt(maxBetsRace),
                max_payout_usd: maxPayoutUsd === '' ? null : parseFloat(maxPayoutUsd),
                max_payout_ves: maxPayoutVes === '' ? null : parseFloat(maxPayoutVes)
            }));

            if (amount > 0) {
                let amountUSD = amount;
                if (currency === 'VES') {
                    if(!remateState.exchangeRate || remateState.exchangeRate <= 0) {
                        throw new Error("Tasa de cambio no válida.");
                    }
                    amountUSD = amount / remateState.exchangeRate;
                }
                promises.push(api.post('/remate/users/balance', {
                    user_id: user.id, amount_usd: amountUSD, operation_type: type,
                    description: `Admin ${type === 'CREDIT' ? 'Recarga' : 'Retiro'} (${currency} ${amount})`
                }));
            }

            await Promise.all(promises);

            Notification(notificationContainer, "Datos y saldo actualizados correctamente", "success");
            modal.remove();
            onSave();
        } catch (e) { 
            Notification(notificationContainer, e.message || "Error de conexión", "error"); 
            btn.disabled = false;
            btn.innerHTML = 'Guardar Todo';
        }
    };
    modal.querySelector('#cancel-balance').onclick = () => modal.remove();
};

const openAllyModal = async (user, notificationContainer, onSave) => {
    const currentAlly = user.ally_name || '';
    
    Notification(notificationContainer, 'Cargando operadores...', 'info');

    let systemUsers = [];
    try {
        const allUsers = await api.get('/users?role=payout_agent');
        systemUsers = allUsers.filter(u => u.role === 'payout_agent');
    } catch (error) {
        return Notification(notificationContainer, 'Error al cargar la lista de operadores.', 'error');
    }

    let optionsHtml = '<option value="">-- Directo (Sin Operador) --</option>';
    systemUsers.forEach(su => {
        const displayName = su.full_name ? `${su.full_name} (${su.username})` : su.username;
        const valueName = su.username;
        const isSelected = currentAlly === valueName ? 'selected' : '';
        optionsHtml += `<option value="${valueName}" ${isSelected}>${displayName} - Rol: ${su.role.toUpperCase()}</option>`;
    });

    const content = `
        <h3 style="color:#3b82f6; text-align:center; margin-bottom:10px;"><i class="fas fa-user-tie"></i> Asignar Operador</h3>
        <p style="text-align:center; margin-bottom:15px; color: #94a3b8; font-size:0.9rem;">Usuario App: <b style="color:white;">${user.alias}</b></p>
        
        <div class="form-group" style="text-align:left;">
            <label style="color:#cbd5e1; margin-bottom:5px; display:block; font-weight:bold;">Seleccionar Operador del Sistema:</label>
            <select id="ally-input-name" class="remate-select" style="width:100%; padding:10px; background:#0f172a; color:white; border:1px solid #475569; border-radius:5px;">
                ${optionsHtml}
            </select>
        </div>
        
        <div style="display:flex; gap:10px; margin-top:20px;">
            <button id="cancel-ally" class="btn btn-secondary" style="flex:1;">Cancelar</button>
            <button id="confirm-ally" class="btn btn-primary" style="flex:1; background:#3b82f6; color:white;">Guardar Asignación</button>
        </div>
    `;
    
    const modal = createModal('ally-modal', content);
    document.body.appendChild(modal);

    modal.querySelector('#confirm-ally').onclick = async () => {
        const allyName = modal.querySelector('#ally-input-name').value;
        const btn = modal.querySelector('#confirm-ally');
        btn.disabled = true; btn.innerText = 'Guardando...';

        try {
            await api.post('/remate/users/ally', { userId: user.id, allyName: allyName });
            modal.remove();
            onSave();
            Notification(notificationContainer, 'Operador asignado correctamente.', 'success');
        } catch (e) { 
            Notification(notificationContainer, e.message || "Error de red", "error");
            btn.disabled = false; btn.innerText = 'Guardar Asignación';
        }
    };
    
    modal.querySelector('#cancel-ally').onclick = () => modal.remove();
};

const renderFilteredUsers = (usersArray, container, notificationContainer, onSave) => {
    const tbody = container.querySelector('#remate-users-body');
    if(!tbody) return;
    tbody.innerHTML = '';
    
    if (usersArray.length === 0) {
        tbody.innerHTML = '<tr><td colspan="6" class="text-center text-gray-500 py-4">No se encontraron usuarios con ese criterio</td></tr>';
        return;
    }

    usersArray.forEach(u => {
        const balanceUSD = parseFloat(u.balance_usd || 0);
        const balanceBS = (balanceUSD * remateState.exchangeRate).toFixed(2);
        const alias = u.alias || u.telegram_username || `ID: ${u.telegram_id}`;
        const phone = u.phone_number || '<span style="color:#64748b; font-size:0.8rem;">No Registrado</span>';
        const allyText = u.ally_name ? u.ally_name : '<span style="color:#ef4444; font-style:italic;">Directo</span>';

        const tr = document.createElement('tr');
        tr.innerHTML = `
            <td class="font-bold" style="color:var(--gold-shine); font-size:1.05rem;">${alias}</td>
            <td style="color:#cbd5e1; font-size:0.9rem;">${phone}</td>
            <td style="color:#cbd5e1; font-size:0.9rem;"><i class="fas fa-user-tie" style="color:#94a3b8; margin-right:4px;"></i> ${allyText}</td>
            <td style="color:#4ade80; font-family:monospace; font-weight:bold; font-size:1.15rem;">$${balanceUSD.toFixed(2)}</td>
            <td style="color:#94a3b8; font-family:monospace; font-size:1rem;">Bs ${balanceBS}</td>
            <td>
                <div style="display:flex; gap:10px; flex-wrap:wrap;">
                    <button class="btn-action btn-edit-ally" style="padding:8px 15px; font-size:0.95rem; background:#3b82f6; border-radius:6px; box-shadow: 0 2px 4px rgba(0,0,0,0.4);" title="Asignar Operador">
                        <i class="fas fa-briefcase"></i> Operador
                    </button>
                    <button class="btn-action btn-edit-balance" style="padding:8px 15px; font-size:0.95rem; background:#10b981; border-radius:6px; box-shadow: 0 2px 4px rgba(0,0,0,0.4); color:#064e3b;" title="Recargar/Retirar Saldo">
                        <i class="fas fa-wallet"></i> Caja
                    </button>
                </div>
            </td>
        `;
        tr.querySelector('.btn-edit-balance').onclick = () => openBalanceModal(u, notificationContainer, onSave);
        tr.querySelector('.btn-edit-ally').onclick = () => openAllyModal(u, notificationContainer, onSave);
        tbody.appendChild(tr);
    });
};

const loadRemateUsers = async (container, notificationContainer) => {
    const tbody = container.querySelector('#remate-users-body');
    if(!tbody) return;
    
    tbody.innerHTML = '<tr><td colspan="6" class="text-center text-gray-500 py-4"><i class="fas fa-spinner fa-spin text-2xl"></i> Cargando...</td></tr>';

    try {
        const users = await api.get('/remate/users'); 
        remateState.users = users;
        
        const filterInput = container.querySelector('#filter-user-phone');
        if (filterInput && filterInput.value.trim() !== '') {
            const searchTerm = filterInput.value.toLowerCase().trim();
            const filteredUsers = users.filter(u => {
                const phone = (u.phone_number || '').toLowerCase();
                const alias = (u.alias || u.telegram_username || '').toLowerCase();
                return phone.includes(searchTerm) || alias.includes(searchTerm);
            });
            renderFilteredUsers(filteredUsers, container, notificationContainer, () => loadRemateUsers(container, notificationContainer));
        } else {
            renderFilteredUsers(users, container, notificationContainer, () => loadRemateUsers(container, notificationContainer));
        }
    } catch (error) { 
        tbody.innerHTML = '<tr><td colspan="6" class="text-center text-red-500 font-bold py-4">Error cargando usuarios</td></tr>'; 
    }
};

const loadRemateTracks = async (container) => {
    try {
        const tracks = await api.get('/remate/tracks'); 
        const select = container.querySelector('#remate-track-select');
        if(!select) return;
        select.innerHTML = '<option value="">Seleccione...</option>';
        if(tracks.length === 0) { select.innerHTML += '<option value="" disabled>No hay hipódromos activos hoy</option>'; return; }
        tracks.forEach(t => { select.innerHTML += `<option value="${t.id}">${t.name}</option>`; });
    } catch (e) { console.error("Error cargando tracks:", e); }
};

const loadRemateHorses = async (raceId, container) => {
    const tbody = container.querySelector('#remate-horses-body');
    if(!tbody) return;
    tbody.innerHTML = '<tr><td colspan="4" class="text-center">Cargando ejemplares...</td></tr>';

    try {
        const data = await api.get(`/remate/horses/${raceId}`);
        const horses = data.horses || [];
        tbody.innerHTML = '';

        if(horses.length === 0) { tbody.innerHTML = '<tr><td colspan="4" class="text-center">No hay caballos inscritos.</td></tr>'; return; }

        // ⭐ FIX POKA-YOKE: Extraemos la configuración para saber si ya se fijaron precios manualmente
        let wData = {};
        if (data.race_info && data.race_info.wagers_data) {
            wData = typeof data.race_info.wagers_data === 'string' ? JSON.parse(data.race_info.wagers_data) : data.race_info.wagers_data;
        }
        const pricesSet = wData.prices_set === true;

        horses.forEach(h => {
            const tr = document.createElement('tr');
            
            // ⭐ FIX: Si no se han fijado precios (prices_set = false), ignoramos el valor de BD y forzamos a 0
            const val = pricesSet ? (h.base_price !== undefined && h.base_price !== null ? h.base_price : 0) : 0; 
            
            tr.innerHTML = `
                <td class="text-center font-bold" style="background:#334155; color:#D4AF37; border-radius:50%; width:35px; height:35px; display:flex; align-items:center; justify-content:center;">${h.horse_number}</td>
                <td>${h.name}</td>
                <td><div style="display: flex; align-items: center; gap: 5px;"><span style="color:#4ade80;">$</span><input type="number" id="base-price-${h.id}" class="remate-input" value="${val}" min="0" step="1" style="width: 80px;"></div></td>
                <td><button class="btn-success btn-sm" id="btn-save-${h.id}">💾</button></td>
            `;
            
            tr.querySelector(`#btn-save-${h.id}`).onclick = async () => {
                const inputVal = document.getElementById(`base-price-${h.id}`).value;
                const newVal = inputVal === '' ? 0 : parseFloat(inputVal);
                if (isNaN(newVal)) { return; }
                try {
                    await api.post('/remate/set-base-price', { horse_id: h.id, race_id: parseInt(raceId), base_price: newVal });
                    const btn = tr.querySelector(`#btn-save-${h.id}`);
                    btn.innerHTML = '✅'; btn.disabled = true;
                    setTimeout(() => { btn.innerHTML = '💾'; btn.disabled = false; }, 1500);
                } catch (err) { console.error('Error al guardar precio base'); }
            };
            tbody.appendChild(tr);
        });
    } catch (e) { tbody.innerHTML = '<tr><td colspan="4" class="text-center text-red-500">Error al cargar datos</td></tr>'; }
};

export async function renderRemateManagement(container, notificationContainer) {
    container.innerHTML = `
        <div class="remate-dashboard">
            <div class="remate-panel">
                 <div class="remate-header" style="margin-bottom:10px;">
                    <span>👥 Usuarios (Saldos)</span> 
                    <button id="btn-refresh-users" class="btn-action">🔄</button>
                 </div>
                 <div style="margin-bottom: 15px;">
                     <input type="text" id="filter-user-phone" class="remate-input" placeholder="🔍 Filtrar por teléfono o alias..." style="padding: 10px; width: 100%;">
                 </div>
                 <div style="max-height: 400px; overflow-y: auto;">
                    <table class="remate-table">
                        <thead><tr><th>Usuario</th><th>Teléfono</th><th>Operador</th><th>Saldo $</th><th>Saldo Bs</th><th>Acciones</th></tr></thead>
                        <tbody id="remate-users-body"><tr><td colspan="6" class="text-center">Cargando...</td></tr></tbody>
                    </table>
                </div>
            </div>

            <div class="remate-panel">
                <div class="remate-header"><span>🏇 Configurar Carrera (Remate)</span></div>
                <div style="margin-bottom:15px;">
                    <select id="remate-track-select" class="remate-select mb-2"><option>Cargando Hipódromos...</option></select>
                    
                    <div id="track-controls" class="hidden p-4 bg-[#0f172a] rounded-lg border border-[#334155] shadow-inner mb-3">
                        <label style="color:#D4AF37; font-weight:bold; display:block; margin-bottom:5px;"><i class="fas fa-file-pdf"></i> Gaceta del Hipódromo</label>
                        <div style="display:flex; gap:10px; align-items:center;">
                            <input type="file" id="cfg-track-gaceta-file" accept="application/pdf" class="remate-input" style="padding:5px; margin-bottom: 0;">
                            <button id="btn-save-track-gaceta" class="btn-primary" style="padding:10px 15px; white-space:nowrap;"><i class="fas fa-upload"></i> Subir</button>
                        </div>
                    </div>

                    <select id="remate-race-select" class="remate-select mb-2" disabled><option>Seleccione Carrera...</option></select>
                    
                    <div id="race-controls" class="hidden p-4 bg-[#0f172a] rounded-lg border border-[#334155] shadow-inner mt-2">
                        
                        <h4 style="color:#f8fafc; font-size:0.9rem; margin-top:0; margin-bottom:10px; border-bottom:1px solid #334155; padding-bottom:5px;"><i class="fas fa-cog"></i> Valores Financieros</h4>
                        <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom:15px;">
                            <div>
                                <label style="color:#94a3b8; font-weight:bold; display:block; margin-bottom:5px;">Retención Casa (%)</label>
                                <input type="number" id="race-percent" class="remate-input" value="25" style="font-weight:bold; color:#10b981;">
                            </div>
                            <div>
                                <label style="color:#94a3b8; font-weight:bold; display:block; margin-bottom:5px;">Llenar Pote Extra ($)</label>
                                <input type="number" id="manual-pote" class="remate-input" placeholder="0.00" style="font-weight:bold; color:#D4AF37;">
                            </div>
                        </div>

                        <h4 style="color:#f8fafc; font-size:0.9rem; margin-top:10px; margin-bottom:10px; border-bottom:1px solid #334155; padding-bottom:5px;"><i class="fas fa-clock"></i> Reglas de Cierre Automático</h4>
                        <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom:15px;">
                            <div>
                                <label style="color:#94a3b8; font-weight:bold; display:block; margin-bottom:5px;" title="Tiempo de duración desde que se fija el primer precio > 0">Duración Sala (Minutos)</label>
                                <input type="number" id="race-duration" class="remate-input" value="0" placeholder="Ej: 15" style="font-weight:bold; color:#a855f7;">
                            </div>
                            <div>
                                <label style="color:#94a3b8; font-weight:bold; display:block; margin-bottom:5px;">Acción de Cierre por MTP</label>
                                <select id="race-close-before" class="remate-select" style="font-weight:bold; color:#f43f5e;">
                                    <option value="2">Cerrar 2 min ANTES de MTP 0</option>
                                    <option value="1">Cerrar 1 min ANTES de MTP 0</option>
                                    <option value="0" selected>Cerrar EXACTAMENTE en MTP 0</option>
                                    <option value="-1">Cerrar 1 min DESPUÉS de MTP 0</option>
                                    <option value="-2">Cerrar 2 min DESPUÉS de MTP 0</option>
                                </select>
                            </div>
                        </div>
                        <p style="font-size: 0.75rem; color: #64748b; margin-top: -5px; margin-bottom: 15px;">* Si ingresas una Duración > 0, el reloj ignorará el MTP y solo arrancará cuando asignes un precio.</p>
                        
                        <div style="display:flex; gap: 10px; margin-top:10px;">
                            <button id="btn-save-config" class="btn-success" style="flex:2; padding:12px; font-size:1rem;"><i class="fas fa-save"></i> Guardar Configuración</button>
                            <button id="btn-roulette-tablazo" class="btn-primary" style="flex:1;"><i class="fas fa-dice"></i> Tablazo</button>
                        </div>
                        <button id="btn-close-race" class="btn-danger mt-3 w-full" style="padding:10px; font-weight:900; letter-spacing:1px;"><i class="fas fa-lock"></i> CERRAR APUESTAS MANUALMENTE</button>
                    </div>
                </div>

                <div style="max-height: 300px; overflow-y: auto; border-top:2px solid #334155; padding-top:15px;">
                    <h4 style="color:#94a3b8; margin-bottom:10px;">Ajuste de Precios Base</h4>
                    <table class="remate-table">
                        <thead><tr><th>#</th><th>Ejemplar</th><th>Base $</th><th>Guardar</th></tr></thead>
                        <tbody id="remate-horses-body"><tr><td colspan="4" class="text-center text-gray-500">Seleccione una carrera primero...</td></tr></tbody>
                    </table>
                </div>
            </div>
        </div>
    `;

    try {
        const conf = await api.get('/configs/cashier');
        remateState.exchangeRate = parseFloat((Array.isArray(conf) ? conf[0] : conf).exchange_rate || 0);
        await loadRemateUsers(container, notificationContainer);
        await loadRemateTracks(container); 
    } catch (e) { console.error("Error init remate:", e); }

    const trackSel = container.querySelector('#remate-track-select');
    const trackControls = container.querySelector('#track-controls');
    const btnSaveTrackGaceta = container.querySelector('#btn-save-track-gaceta');

    const raceSel = container.querySelector('#remate-race-select');
    const raceControls = container.querySelector('#race-controls');
    const btnSaveConfig = container.querySelector('#btn-save-config');
    const btnClose = container.querySelector('#btn-close-race');
    const btnRoulette = container.querySelector('#btn-roulette-tablazo');
    const filterInput = container.querySelector('#filter-user-phone');

    if (filterInput) {
        filterInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.toLowerCase().trim();
            const filteredUsers = remateState.users.filter(u => {
                const phone = (u.phone_number || '').toLowerCase();
                const alias = (u.alias || u.telegram_username || '').toLowerCase();
                return phone.includes(searchTerm) || alias.includes(searchTerm);
            });
            renderFilteredUsers(filteredUsers, container, notificationContainer, () => loadRemateUsers(container, notificationContainer));
        });
    }

    trackSel.onchange = async () => {
        remateState.currentTrackId = trackSel.value;
        raceSel.innerHTML = '<option>Cargando...</option>'; 
        raceSel.disabled = true; 
        raceControls.classList.add('hidden');
        if(trackControls) trackControls.classList.add('hidden');
        container.querySelector('#remate-horses-body').innerHTML = '<tr><td colspan="4" class="text-center">Seleccione una carrera...</td></tr>';
        
        if(remateState.currentTrackId) {
            if(trackControls) trackControls.classList.remove('hidden');
            try {
                const races = await api.get(`/remate/races/${remateState.currentTrackId}`);
                raceSel.innerHTML = '<option value="">-- Seleccione Carrera --</option>' + races.map(r => {
                    const icon = r.status === 'open' ? '🟢' : (r.status === 'closed' ? '🔴' : '⚪');
                    const wagersEncoded = encodeURIComponent(JSON.stringify(r.wagers_data || {}));
                    return `<option value="${r.id}" data-percent="${r.house_profit || 25}" data-pote="${r.manual_pote || 0}" data-wagers="${wagersEncoded}" data-start-time="${r.start_time}">${icon} Carrera ${r.race_number} - ${r.name}</option>`;
                }).join('');
                raceSel.disabled = false;
            } catch(e) { raceSel.innerHTML = '<option>Error al cargar</option>'; }
        }
    };

    raceSel.onchange = () => {
        remateState.currentRaceId = raceSel.value;
        if(remateState.currentRaceId) {
            loadRemateHorses(remateState.currentRaceId, container);
            raceControls.classList.remove('hidden');
            
            const opt = raceSel.options[raceSel.selectedIndex];
            container.querySelector('#race-percent').value = opt.getAttribute('data-percent') || 25;
            container.querySelector('#manual-pote').value = opt.getAttribute('data-pote') || 0;
            
            let wagers = {};
            try {
                const wagersRaw = opt.getAttribute('data-wagers');
                wagers = wagersRaw ? JSON.parse(decodeURIComponent(wagersRaw)) : {};
            } catch (err) { console.error("Error parseando wagers_data", err); }

            container.querySelector('#race-close-before').value = wagers.close_before !== undefined ? wagers.close_before : 0;
            container.querySelector('#race-duration').value = wagers.remate_duration !== undefined ? wagers.remate_duration : 0;

        } else {
            raceControls.classList.add('hidden');
            container.querySelector('#remate-horses-body').innerHTML = '<tr><td colspan="4" class="text-center">Seleccione una carrera...</td></tr>';
        }
    };

    if (btnSaveTrackGaceta) {
        btnSaveTrackGaceta.addEventListener('click', async (e) => {
            e.preventDefault();
            const currentFileInput = document.getElementById('cfg-track-gaceta-file');
            
            if (!currentFileInput || currentFileInput.files.length === 0) {
                return Notification(notificationContainer, 'Por favor, selecciona un archivo PDF.', 'warning');
            }
            const fileSizeMB = currentFileInput.files[0].size / (1024 * 1024);
            if (fileSizeMB > 45) {
                return Notification(notificationContainer, `El archivo pesa ${fileSizeMB.toFixed(1)}MB. El límite es 45MB.`, 'error');
            }

            const originalText = btnSaveTrackGaceta.innerHTML;
            btnSaveTrackGaceta.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Subiendo...';
            btnSaveTrackGaceta.disabled = true;

            try {
                const formData = new FormData();
                formData.append('trackId', remateState.currentTrackId);
                formData.append('gaceta', currentFileInput.files[0]); 

                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/remate/admin/race/config', true);
                xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('token')}`);

                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = Math.round((event.loaded / event.total) * 100);
                        btnSaveTrackGaceta.innerHTML = `<i class="fas fa-spinner fa-spin"></i> Subiendo... ${percentComplete}%`;
                    }
                };

                xhr.onload = () => {
                    try {
                        if (xhr.status === 413) throw new Error('El archivo es muy grande (Error 413).');
                        let result = {};
                        try { result = JSON.parse(xhr.responseText); } catch(err) { throw new Error('Respuesta inválida.'); }

                        if (xhr.status >= 200 && xhr.status < 300 && result.success) {
                            Notification(notificationContainer, 'Gaceta subida exitosamente.', "success");
                            currentFileInput.value = ''; 
                        } else throw new Error(result.error || `Error: ${xhr.status}`);
                    } catch(e) {
                        Notification(notificationContainer, "⚠️ " + (e.message || "Error"), "error");
                    } finally {
                        btnSaveTrackGaceta.innerHTML = originalText;
                        btnSaveTrackGaceta.disabled = false;
                    }
                };
                xhr.onerror = () => {
                    Notification(notificationContainer, "⚠️ Error de red.", "error");
                    btnSaveTrackGaceta.innerHTML = originalText; btnSaveTrackGaceta.disabled = false;
                };
                xhr.send(formData);
            } catch(e) { 
                Notification(notificationContainer, "⚠️ Error", "error"); 
            }
        });
    }

    btnSaveConfig.onclick = async () => {
        const val = parseFloat(container.querySelector('#race-percent').value);
        const pote = parseFloat(container.querySelector('#manual-pote').value) || 0;
        const closeBefore = parseInt(container.querySelector('#race-close-before').value) || 0;
        const duration = parseInt(container.querySelector('#race-duration').value) || 0;
        
        if(isNaN(val)) return Notification(notificationContainer, "Porcentaje inválido", "error");

        const originalText = btnSaveConfig.innerHTML;
        btnSaveConfig.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Guardando...';
        btnSaveConfig.disabled = true;

        try {
            const formData = new FormData();
            formData.append('raceId', remateState.currentRaceId);
            formData.append('house_profit', val);
            formData.append('manual_pote', pote);
            formData.append('wagers_data', JSON.stringify({ close_before: closeBefore, remate_duration: duration })); 

            const response = await fetch('/api/remate/admin/race/config', {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.error || `Error: ${response.status}`);
            
            Notification(notificationContainer, 'Configuración y MTP guardados.', "success");
            trackSel.dispatchEvent(new Event('change'));
        } catch(e) { 
            Notification(notificationContainer, "⚠️ " + (e.message || "Error"), "error"); 
        } finally {
            btnSaveConfig.innerHTML = originalText;
            btnSaveConfig.disabled = false;
        }
    };

    btnClose.onclick = async () => {
        if(!confirm("⚠️ ¿Estás seguro que deseas CERRAR MANUALMENTE las apuestas para esta carrera?")) return;
        try {
            const nowUTC = moment().utc().toISOString();
            await api.put(`/races/${remateState.currentRaceId}`, { status: 'closed', start_time: nowUTC });
            Notification(notificationContainer, "✅ Carrera Cerrada Absolutamente", "success");
            trackSel.dispatchEvent(new Event('change')); 
        } catch(e) { 
            Notification(notificationContainer, "Error al cerrar", "error"); 
        }
    };

    btnRoulette.onclick = async () => {
        if(!confirm("¿Deseas activar el sorteo de la Ruleta del Tablazo para esta carrera?")) return;
        try {
            await api.post('/remate/tablazo/spin', { raceId: remateState.currentRaceId });
            Notification(notificationContainer, "🎲 Ruleta activada para los usuarios!", "success");
        } catch (e) { 
            Notification(notificationContainer, "Error activando ruleta", "error"); 
        }
    };

    container.querySelector('#btn-refresh-users').onclick = () => loadRemateUsers(container, notificationContainer);
}